import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class BodyPaintManualService {

  // below endpoint URL with Web API localhost:8080 in Dev or Prod environments
  private endpointURL_All = 'body-and-paint-manual/all';
  private endpointURL_New = 'body-and-paint-manual/new';


  constructor(private http: HttpClient) { }

  getAllBodyPaintManuals(): Observable<any> {
    return this.http.get(this.endpointURL_All, {withCredentials : true});
  }

  getAllBodyPaintManualsForAdmin(makeName): Observable<any> {
    return this.http.get(this.endpointURL_All + '/makeName/' + makeName, {withCredentials : true});
  }

  getNewBodyPaintManuals(): Observable<any> {
    return this.http.get(this.endpointURL_New, {withCredentials : true});
  }

  getRecentBodyPaintManuals(userId): Observable<any> {
    return this.http.get(`user-info/qID/${userId}/bodyAndPaintManualHistorylist`, {withCredentials : true});
  }
  addManualToUserHistory(userId, manualId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addBodyAndPaintManualToHistorylist/${manualId}`, '', {withCredentials : true});
  }

}
